import { i18n } from 'next-i18next';

const formatLocationName = (location: string): string => (
  i18n?.t(location, { ns: 'location-overrides' }) ?? location
);

export default formatLocationName;
